import { NgModule } from '@angular/core';
import { SphereMonacoService } from './sphere-monaco.service';

@NgModule({
    imports: [],
    declarations: [],
    providers: [SphereMonacoService],
    exports: []
})
export class SphereMonacoModule {}
